/**
 * 数値入力欄の draft 文字列を数値へ変換する。
 * 空文字・空白のみ・数値化できない文字列は null を返す(確定時に現在値へ戻す判断に使う)。
 */
export function parseNumericDraft(draft: string): number | null {
  const trimmed = draft.trim();
  if (trimmed === "") return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}

/** value を [min, max] に丸める。min / max は省略可(省略側は制限しない)。 */
export function clampToRange(
  value: number,
  min?: number,
  max?: number,
): number {
  let result = value;
  if (typeof min === "number") result = Math.max(min, result);
  if (typeof max === "number") result = Math.min(max, result);
  return result;
}

/**
 * draft を確定(blur / Enter)したときに反映すべき数値を決める。
 *
 * - 空・非数値の draft は現在値を維持する。毎キー clamp による発振(1桁目が
 *   下限へ丸められる)や、欄を空にした瞬間の 0 への丸めを避ける。
 * - 数値の draft は [min, max] へ丸める。途中経過が範囲外でも確定時に正しく丸まる。
 */
export function resolveCommittedNumber(
  draft: string,
  currentValue: number,
  min?: number,
  max?: number,
): number {
  const parsed = parseNumericDraft(draft);
  if (parsed === null) return currentValue;
  return clampToRange(parsed, min, max);
}
